import { useNavigate, useParams } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Checkbox,
  Chip,
  Container,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { deleteSpaces } from "app/utils";
import { useTelefonosContext } from "../telefonos-context";
import { TelefonoProvider, useTelefonoContext } from "./telefono-context";
import { telefonoRegex } from "app/utils/regexps";
import { MdArrowBack } from "react-icons/md";

export function TelefonoForm() {
  return (
    <TelefonoProvider>
      <Form />
    </TelefonoProvider>
  );
}

function Form() {
  const params = useParams();
  const navigate = useNavigate();

  const { addTelefono, isAdding, updateTelefono, isUpdating, cancel } =
    useTelefonosContext();

  const { telefono, setTelefono, isEditing } = useTelefonoContext();

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (!!isEditing) {
        return await updateTelefono({
          telefonoId: params.telefono_id,
          telefono,
        });
      } else {
        return await addTelefono({ telefono });
      }
    } catch (error) {
      console.log(error.message);
    }
  }

  return (
    <Container maxWidth="sm" className="animate__animated animate__fadeIn">
      <Paper
        component="form"
        onSubmit={handleSubmit}
        onReset={cancel}
        variant="outlined"
        sx={{ padding: 2 }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <Tooltip title="Atrás">
                  <IconButton
                    onClick={() => navigate("../..", { replace: true })}
                  >
                    <MdArrowBack />
                  </IconButton>
                </Tooltip>

                <Typography variant="h6">
                  {`${!!isEditing ? "Editar" : "Agregar"} número de teléfono`}
                </Typography>
              </Stack>

              {!!isEditing && (
                <Chip
                  label={
                    !!telefono.telefono_verificado ? "Verificado" : "Pendiente"
                  }
                  color={!!telefono.telefono_verificado ? "success" : "warning"}
                  variant="outlined"
                  size="small"
                />
              )}
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text"
              label="Número de teléfono"
              value={telefono.telefono_numero}
              onChange={(e) =>
                setTelefono((telefono) => ({
                  ...telefono,
                  telefono_numero: deleteSpaces(e.target.value),
                }))
              }
              inputProps={{
                pattern: telefonoRegex.pattern,
                title: telefonoRegex.title,
              }}
              size="small"
              fullWidth
              required
              disabled={!!telefono.telefono_verificado}
            />
          </Grid>

          <Grid item xs={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={telefono.telefono_principal}
                    onChange={(e) =>
                      setTelefono((telefono) => ({
                        ...telefono,
                        telefono_principal: e.target.checked,
                      }))
                    }
                  />
                }
                label="¿Es un número de teléfono principal?"
                disabled={!!telefono.telefono_verificado}
              />
            </FormGroup>
          </Grid>

          {!telefono.telefono_verificado && (
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="end" spacing={1}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  size="small"
                  color={!!isEditing ? "warning" : "success"}
                  loading={!!isUpdating || !!isAdding}
                >
                  {!!isEditing ? "Actualizar" : "Agregar"}
                </LoadingButton>

                <Button
                  type="reset"
                  variant="outlined"
                  size="small"
                  color="inherit"
                  disabled={!!isUpdating || !!isAdding}
                >
                  Cancelar
                </Button>
              </Stack>
            </Grid>
          )}
        </Grid>
      </Paper>
    </Container>
  );
}
